import type { TFunction } from 'i18next'
import type { EffectiveRoleSource } from '../types/effectiveRoles.types'

// These take a plain TFunction: the iam lib is type-checked in apps whose
// translations do not declare these keys, and only admin-dashboard renders them.

export type NonGroupRoleSource = Exclude<EffectiveRoleSource, { type: 'group' }>

// One line of text for why a role is held: "from Manager", "assigned directly".
// A group source is rendered with links instead (RoleSources).
export const describeRoleSource = (
  source: NonGroupRoleSource,
  t: TFunction
): string => {
  switch (source.type) {
    case 'direct':
      return t('effectiveRoles.source.direct')
    case 'role':
      return t('effectiveRoles.source.role', { role: source.role.name })
    case 'not_visible':
      return t('effectiveRoles.source.notVisible')
    case 'unattributed':
      return t('effectiveRoles.source.unattributed')
  }
}

export const viaGroupLabel = (t: TFunction): string =>
  t('effectiveRoles.source.viaGroup')

export const heldRolesCount = (count: number, t: TFunction): string =>
  t('effectiveRoles.heldCount', { count })

// Leads the roles of its own domain a role implies, shown as badges after it.
export const includesLabel = (t: TFunction): string =>
  t('effectiveRoles.includes')
